/**
 * API URL Constants
 * Centralized API endpoint definitions for Basiq360 Web Platform
 */

// =====================================================
// AUTHENTICATION API - Enterprise Level
// =====================================================
export const API_WEB_CORPORATE_LOGIN = "/auth/web/corporate-login";
export const API_WEB_FIELD_USER_LOGIN = "/auth/web/field-user-login";
export const API_SEND_FIELD_USER_OTP = "/auth/web/send-field-user-otp";
export const API_WEB_LOOKUP_USER = "/auth/web/lookup-user";
export const API_WEB_ORGANIZATION_BRANDING = "/auth/web/organization-branding";
export const API_WEB_VERIFY_OTP = "/auth/web/verify-otp";
export const API_WEB_RESEND_OTP = "/auth/web/resend-otp";
export const API_WEB_RESEND_OTP_GENERIC = "/auth/web/resend-otp-generic";
export const API_WEB_REFRESH_TOKEN = "/auth/web/refresh-token";
export const API_WEB_LOGOUT = "/auth/web/logout";

// =====================================================
// FORGOT PASSWORD / RESET PASSWORD
// =====================================================
export const API_WEB_FORGOT_PASSWORD = "/auth/web/forgot-password";
export const API_WEB_VERIFY_RESET_TOKEN = "/auth/web/verify-reset-token";
export const API_WEB_RESET_PASSWORD = "/auth/web/reset-password";

// =====================================================
// AUTHORIZATION API
// =====================================================
export const API_WEB_GET_USER_PERMISSIONS = "/auth/web/get-user-permissions";
export const API_WEB_GET_USER_MODULES = "/web/authorization/modules";
